require('./bootstrap');
require('flowbite');
const { Modal } = require('flowbite');
const { iniciarContadorCO2 } = require('./utils/counter-kilos');
const { initTabTitleNotifier } = require('./utils/tab-title-notifier');
const {IndicadoresEconomicos} = require('./utils/economicIndicators');

document.addEventListener("DOMContentLoaded", function() {
    /*    const loader = document.getElementById('loading');
        if (loader) {
            // Espera 3 segundos antes de iniciar la animación de ocultar el loader
            setTimeout(() => {
                loader.classList.add('fade-out');
                // Espera el tiempo de la animación antes de ocultar el loader completamente
                setTimeout(() => {
                    loader.style.display = 'none';
                }, 1000); // Debe coincidir con la duración de la animación (1s = 1000ms)
            }, 3000);
        }*/

    iniciarContadorCO2();
    initTabTitleNotifier();
    const indicadores = new IndicadoresEconomicos();
    indicadores.init();
    const modalElement = document.getElementById('modal-popup');

    if (modalElement)
    {
        const modal = new Modal(modalElement, {
            backdropClasses: 'bg-black/50 fixed inset-0 z-40'
        });

        modal.show();
    }

    const btnOpenGetnet = document.getElementById('modal-getnet-pay');
    const btnOpenPresencial = document.querySelector('.btn-presencial');
    const modalGetnetEl = document.getElementById('modal-getnet');
    const modalGetnetPresencialEl = document.getElementById('modal-getnet-presencial');

    if (btnOpenGetnet && btnOpenPresencial && modalGetnetEl && modalGetnetPresencialEl) {
        const modalGetnet = new Modal(modalGetnetEl);
        const modalGetnetPresencial = new Modal(modalGetnetPresencialEl);

        btnOpenGetnet.addEventListener('click', function(e) {
            e.preventDefault();
            modalGetnet.show();
        });

        btnOpenPresencial.addEventListener('click', function(e) {
            e.preventDefault();
            modalGetnet.hide();
            modalGetnetPresencial.show();
        });
    }



});

